<template>
  <page-option
    :filter.sync="filter"
    :title="$t('sidebar.logs.name')"
    use-reload
    use-sider-bar
    @click:reload="resetData()"
    @click:resetFilter="onResetFilter"
  >
    <template #title>
      <v-avatar color="#E3FCF7" size="35">
        <v-icon color="#108F6E" size>mdi-notebook</v-icon>
      </v-avatar>
      <div class="pl-2 title-page"> {{ $t('sidebar.logs.name') }}</div>
    </template>
    <template v-slot:extend-siderbar>
      <v-row class="ma-0">
        <v-col cols="12">
          <field-group>
            <template v-slot:input>
              <FieldSearch
                v-model="filter.search"
                @blur="fetchData(1)"
                @keyup.enter.native="fetchData(1)"
              ></FieldSearch>
            </template>
          </field-group>
        </v-col>
        <v-col cols="12">
          <FieldSelectDate
            initSelect="all"
            :label="$t('sidebar.logs.filter.updated_at')"
            :time-end.sync="filter.date_end"
            :time-start.sync="filter.date_start"
            @change="fetchData(1)"
          ></FieldSelectDate>
        </v-col>
        <v-col cols="12">
          <FieldGroup
            clearable
            :label="$t('sidebar.logs.filter.action')"
            multiple
            no-label
          >
            <template v-slot:input>
              <v-autocomplete
                v-model="filter.methods"
                class="small-input  "
                clearable
                deletable-chips
                dense
                hideDetails
                item-text="name"
                item-value="id"
                :items="categories"
                :label="$t('sidebar.logs.filter.action')"
                multiple
                outlined
                small-chips
                type-input="v-autocomplete"
                @change="fetchData()"
              >
              </v-autocomplete>
            </template>
          </FieldGroup>
        </v-col>
      </v-row>
    </template>

    <v-card class="fillheight " flat tile>
      <div class="px-2">
        <activitylog-table :loading="loading" :logs="logs"></activitylog-table>
        <div v-if="!loading" v-intersect="onIntersect"></div>
      </div>
    </v-card>
  </page-option>
</template>

<script>
import { API_DASHBOARD } from '@api'
import ActivitylogTable from '@components/activitylog-table.vue'
import FieldSearch from '@components/field/field-search-text.vue'
import FieldSelectDate from '@components/field/field-select-date.vue'

export default {
  components: {
    FieldSearch,
    FieldSelectDate,
    ActivitylogTable,
    // FieldMetadata,
  },
  props: {},
  data: (vm) => ({
    categories: [
      {
        icon: 'mdi-plus',
        id: 'created',
        name: vm.$t('activitylog.actions.created'),
        color: 'primary',
      },
      {
        icon: 'mdi-wrench',
        id: 'updated',
        name: vm.$t('activitylog.actions.updated'),
        color: 'primary',
      },
      {
        icon: 'mdi-trash-can-outline',
        id: 'deleted',
        name: vm.$t('activitylog.actions.deleted'),
        color: 'red',
      },
      {
        icon: 'mdi-plus',
        id: 'login',
        name: vm.$t('activitylog.actions.login'),
        color: 'primary',
      },
    ],
    paginate: { hasMoreItems: true },
    filter: {},
    loading: true,
    isShowSiderBar: false,
    logs: [],
  }),
  computed: {},
  watch: {},
  created() {
    this.fetchData()
  },
  methods: {
    onIntersect(entries, observer, isIntersecting) {
      if (!this.loading && isIntersecting && this.paginate.hasMoreItems) {
        this.fetchData(this.paginate.page + 1)
      }
    },
    resetData() {
      this.fetchData(1)
    },
    async fetchData(page = 1) {
      this.loading = true
      let params = { ...this.filter }
      params.page = page
      params.itemsPerPage = this.paginate.perpage
      params.paginate = true
      const res = await API_DASHBOARD.getLog(params)
      let data = res.data
      if (data.pagination.page == 1) {
        this.logs = []
      }
      this.logs.push(...data.list)
      this.paginate = data.pagination
      this.loading = false
      return res
    },
    onResetFilter() {
      this.filter = this.$options.data.call(this).filter
      this.fetchData()
    },
  },
}
</script>

<style scoped></style>
